/**
 * CONFIGURATION FILE - Single source of truth for API URLs
 * 1 For local development: use 'http://localhost:5000'
 * 2. For production: use 'https://api.themedicalscrubs.com'
 * 
 * All API calls and image URLs will automatically use these values.
 */

const isProduction = process.env.NODE_ENV === "production";
const API_HOST =
  process.env.REACT_APP_API_HOST ||
  (isProduction ? "https://api.themedicalscrubs.com" : "https://api.themedicalscrubs.com");

// API version path used by admin requests
const API_VERSION = '/api/admin';
const API_URL = `${API_HOST}${API_VERSION}`;

// IMAGE_BASE is the base URL used to construct full image paths returned by
// the backend (for example backend returns "/uploads/.." and we prefix it
// with IMAGE_BASE). Set REACT_APP_IMAGE_BASE to a CDN or production host to
// switch image serving without changing code across files.
const IMAGE_BASE = process.env.REACT_APP_IMAGE_BASE || API_HOST;

/**
 * buildImageUrl(path)
 * - If `path` is empty/falsy, returns empty string.
 * - If `path` looks like an absolute URL (http, https, or protocol-relative //), return it as-is.
 * - If `path` starts with '/', prefix with IMAGE_BASE.
 * - Otherwise prefix with IMAGE_BASE + '/'.
 */
function buildImageUrl(path) {
  if (!path) return '';
  if (/^(https?:)?\/\//i.test(path)) return path;
  if (path.startsWith('/')) return `${IMAGE_BASE}${path}`;
  return `${IMAGE_BASE}/${path}`;
}

export { IMAGE_BASE, buildImageUrl };
export default API_URL;
